import config from 'constants/config'
import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'

/** Read the tour flight rollout without triggering experiment activation or excluding UTM traffic. */
export function getTourFlightsEnabled(state: App.State): boolean {
  const experimentId = ChertoExperiments.flightsToursUpsell.id
  const variationKey = config[`CHERTO_${experimentId}`] ?? state.cherto.chertoExperiments[experimentId]?.variationKey

  return getExperimentEnabledDecision(variationKey)
}
